export default __webpack_public_path__ + "static/media/easytravel.d1a99b27.PNG";